import React from 'react';

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const Logo: React.FC<LogoProps> = ({ className = '', showText = true, size = 'md' }) => {
  const sizeClasses = {
    sm: {
      container: 'h-8 w-8',
      mainText: 'text-xl',
      subText: 'text-xs',
      textSpacing: 'ml-2'
    },
    md: {
      container: 'h-10 w-10',
      mainText: 'text-2xl',
      subText: 'text-sm',
      textSpacing: 'ml-3'
    },
    lg: {
      container: 'h-12 w-12',
      mainText: 'text-3xl',
      subText: 'text-base',
      textSpacing: 'ml-3'
    }
  };

  const sizes = sizeClasses[size];

  return (
    <div className={`flex items-center ${className}`}>
      {showText ? (
        <div className="flex items-center">
          <span className={`${sizes.subText} text-gray-500 dark:text-gray-400 font-light mr-1`}>E</span>
          <div className={`${sizes.container} bg-indigo-600 rounded-lg flex items-center justify-center`}>
            <span className="text-white font-bold text-xl">X</span>
          </div>
          <span className={`${sizes.subText} text-gray-500 dark:text-gray-400 font-light ml-1`}>IT</span>
          <span className={`${sizes.mainText} font-bold text-gray-900 dark:text-white ml-0.5`}>AWS</span>
        </div>
      ) : (
        <div className={`${sizes.container} bg-indigo-600 rounded-lg flex items-center justify-center`}>
          <span className="text-white font-bold text-xl">X</span>
        </div>
      )}
    </div>
  );
};

export default Logo;